import PropTypes from "prop-types";

// Generic modal overlay for strategy detail views.
export default function StrategyOverlay({ open, onClose, title, children }) {
    if (!open) return null;
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
            onClick={onClose}
        >
            <div
                className="bg-gray-900 p-4 rounded shadow-xl max-w-lg w-full"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between mb-2">
                    {title && (
                        <h3 className="text-lg font-semibold text-cyan-300">
                            {title}
                        </h3>
                    )}
                    <button
                        type="button"
                        className="text-gray-400 hover:text-white"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}

StrategyOverlay.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.node,
};


